import { useMutation } from '@tanstack/react-query';
import { useState } from 'react';

import { apiHatasiMi } from '../api/hata';
import { giris } from '../api/kimlik';
import { Alan, Dugme, HataKutusu, Kart } from '../bilesenler/temel';
import { oturumDeposuKullan } from '../durum/oturum-deposu';

/**
 * GİRİŞ EKRANI.
 *
 * Girişten sonra YÖNLENDİRME YAPILMAZ. Depo `asama`yı hesaplar
 * (`acik` / `kisitli`) ve yönlendirme kararını `Uygulama.tsx` verir. Burada
 * `navigate` çağrılsaydı ilk giriş kısıtları iki yerde denetlenirdi ve biri
 * unutulduğunda kullanıcı her isteği 403 alan boş bir panele düşerdi.
 */
export function Giris() {
  const [kullaniciAdi, kullaniciAdiYaz] = useState('');
  const [sifre, sifreYaz] = useState('');
  const kullaniciyiYaz = oturumDeposuKullan((d) => d.kullaniciyiYaz);

  const gonder = useMutation({
    mutationFn: () => giris(kullaniciAdi.trim(), sifre),
    onSuccess: (yanit) => kullaniciyiYaz(yanit.kullanici),
  });

  const alanHatalari = apiHatasiMi(gonder.error) ? gonder.error.alanHatalari : {};

  return (
    <div className="flex min-h-full items-center justify-center p-4">
      <Kart
        baslik="e-alanya · Yönetim Paneli"
        aciklama="Personel numaranız ve şifrenizle giriş yapın."
        cocuk={
          <div className="space-y-4">
            <Alan
              etiket="Personel numarası"
              deger={kullaniciAdi}
              degisti={kullaniciAdiYaz}
              otomatikTamamla="username"
              hatalar={alanHatalari.kullaniciAdi}
              ipucu="TC kimlik numarası değildir."
            />
            <Alan
              etiket="Şifre"
              tur="password"
              deger={sifre}
              degisti={sifreYaz}
              otomatikTamamla="current-password"
              hatalar={alanHatalari.sifre}
            />

            <HataKutusu hata={gonder.error} />

            <Dugme
              tikla={() => gonder.mutate()}
              bekliyor={gonder.isPending}
              pasif={kullaniciAdi.trim() === '' || sifre === ''}
              cocuk="Giriş yap"
            />
          </div>
        }
      />
    </div>
  );
}
